// extracted by mini-css-extract-plugin
module.exports = {"item":"item--77d06","container":"container--d5105","uppercase":"uppercase--3f094"};